export default __webpack_public_path__ + "static/media/target_market_main_img.cdca1653.png";